import React, { useState, useReducer, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Box,
} from "@mui/material";
import { I18n } from "@aws-amplify/core";
import dayjs from "dayjs";
import { post } from "aws-amplify/api";
import currentUserToken from "CurrentUserToken";
import { APIStatusDialog } from "./APIStatusDialog";

function AddClosingPatterns({ open, onClose, onSave, languages }) {
  const [apiStatus, setApiStatus] = useState({
    open: false,
    status: "",
    message: "",
  });

  const AddNewType = async () => {
    try {
      setApiStatus({
        open: true,
        status: "pending",
        message: I18n.get("Adding Close Pattern"),
      });

      if (!languageFields.ENGLISH) {
        throw new Error(I18n.get("English description are required")); // Traduzione
      }

      const requestBody = {};
      Object.keys(languageFields).forEach((language) => {
        if (languageFields[language].trim()) {
          requestBody[language] = languageFields[language].trim();
        }
      });

      const restOperation = post({
        apiName: "TelemonitoringAPI",
        path: "/pattern/type/new",
        options: {
          body: requestBody,
          headers: {
            "Content-Type": "application/json",
            Authorization: `${await currentUserToken()}`,
          },
          queryParams: {
            pattern_type: "CLOSE",
            name: languageFields.ENGLISH,
          },
        },
      });
      const response = await restOperation.response;
      if (response.statusCode === 200) {
        setApiStatus({
          open: true,
          status: "success",
          message: I18n.get("Close Pattern Added"), // Traduzione
        });
      } else {
        setApiStatus({
          open: true,
          status: "error",
          message: I18n.get("Operation Failed"), // Traduzione
        });
      }

      setTimeout(() => {
        setApiStatus((prevState) => ({ ...prevState, open: false }));
        onClose();
      }, 2000);
    } catch (error) {
      setApiStatus({
        open: true,
        status: "error",
        message: I18n.get("Operation Failed"), // Traduzione
      });
      onClose();
    }
  };

  const formatLanguageName = (language) => {
    return I18n.get(
      language.charAt(0).toUpperCase() + language.slice(1).toLowerCase()
    ); // Traduzione dei nomi delle lingue
  };

  const [languageFields, setLanguageFields] = useState(() => {
    const initialFields = {};
    languages.forEach((language) => {
      initialFields[language] = "";
    });
    return initialFields;
  });
  const [languageErrors, setLanguageErrors] = useState({});

  const handleSave = async () => {
    const englishValue = languageFields.ENGLISH || "";
    const englishError = englishValue === "";

    if (englishError) {
      setLanguageErrors({
        ...languageErrors,
        ENGLISH: englishError,
      });
    } else {
      await AddNewType(); // Call AddNewType to save the new alarm type
      onSave({ ...languageFields }); // Pass the data back to the parent component
    }
  };

  const handleLanguageChange = (language, event) => {
    const value = event.target.value;
    setLanguageFields((prevFields) => ({
      ...prevFields,
      [language]: value,
    }));

    if (language === "ENGLISH" && value !== "") {
      setLanguageErrors((prevErrors) => ({
        ...prevErrors,
        ENGLISH: false,
      }));
    }
  };

  // Reset dei campi delle lingue quando il dialogo è aperto
  useEffect(() => {
    if (open) {
      const initialFields = {};
      languages.forEach((language) => {
        initialFields[language] = "";
      });
      setLanguageFields(initialFields);
      setLanguageErrors({});
    }
  }, [open, languages]); // Aggiungi 'languages' come dipendenza se necessario
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{I18n.get("Add New Closing Pattern")}</DialogTitle>{" "}
      <DialogContent>
        <Box component="form" sx={{ mt: 2 }}>
          {languages.map((language) => (
            <TextField
              key={language}
              required={language === "ENGLISH"}
              fullWidth
              label={formatLanguageName(language)} // Traduzione dei nomi delle lingue
              value={languageFields[language]}
              onChange={(event) => handleLanguageChange(language, event)}
              error={language === "ENGLISH" && languageErrors.ENGLISH}
              helperText={
                language === "ENGLISH" && languageErrors.ENGLISH
                  ? I18n.get("English text is required") // Traduzione
                  : ""
              }
              sx={{ mb: 2 }}
            />
          ))}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary">
          {I18n.get("Cancel")} {/* Traduzione */}
        </Button>
        <Button onClick={handleSave} color="primary">
          {I18n.get("Save")} {/* Traduzione */}
        </Button>
      </DialogActions>
      <APIStatusDialog
        open={apiStatus.open}
        status={apiStatus.status}
        message={apiStatus.message}
        onClose={() =>
          setApiStatus((prevState) => ({ ...prevState, open: false }))
        }
      />
    </Dialog>
  );
}

export default AddClosingPatterns;
